module.exports = __webpack_public_path__ + "static/logo-23ad494d1b9339d071ad7bcc571d37e0.png";